import { jsx as _jsx } from "react/jsx-runtime";
import { integrationsGridItems } from "./integrations-tab-consts.js";
import { withGenericConfig } from "/contexts/generic-config-context";
import LiveBoardTabComponent from "../live-board-tab-component";
const IntegrationsTabContentComponent = (props)=>{
    const { translate, onCardClick } = props;
    return /*#__PURE__*/ _jsx("div", {
        className: "integrations-tab-content",
        children: /*#__PURE__*/ _jsx(LiveBoardTabComponent, {
            description: translate("liveBoard.integrationsTab.description"),
            gridItems: integrationsGridItems,
            hideCardParagraph: true,
            onCardClick: onCardClick
        })
    });
};
export default withGenericConfig(IntegrationsTabContentComponent);
